import React from 'react';
import { Link } from 'react-router-dom';
import { PipelineDiagram } from '../components/PipelineDiagram';
import { Triage } from '../components/Triage';
import { SeeIt } from '../components/SeeIt';
import { Faq } from '../components/Faq';
import { CtaBand } from '../components/CtaBand';
import { Ledger } from '../components/Ledger';
import { LibraryChart } from '../components/LibraryChart';
import { ReworkChart } from '../components/how/ReworkChart';
import { PAYOFF } from '../data/payoff';
export function Index() {
  return <>
      <header className="hero" data-id="element-554" data-mp="3vws81fvyy9d7">
        <div className="hgrid" data-id="element-555" data-mp="3vte5a6je7y58">
          <div className="col-l" data-id="element-556" data-mp="dhhnsp5y4u2t">
            <div className="lab-row" data-id="element-557" data-mp="dispmjftzrra">
              <span className="clabel" data-id="element-558" data-mp="8qhsfoch6k2f">The Instruction Layer</span>
            </div>
            <div className="head-block" data-id="element-559" data-mp="8oojg2ee3nr9">
              <h1 style={{
              fontSize: 'clamp(34px,4.35vw,54px)',
              lineHeight: 1.06,
              maxWidth: '21ch'
            }} data-id="element-560" data-mp="3h5ja8jhwxhoz">
                Your best judgment. Built into every answer that matters.
              </h1>
            </div>
            <div className="sub-block" data-id="element-561" data-mp="1uvv48rzkhdfn">
              <p className="sub" data-id="element-562" data-mp="1uv28em25c8ca">
                Synthia brings together what AI needs to honor &mdash; your policies and expertise, regulatory
                requirements, and industry guidance &mdash; and turns it into instruction data any model can act on{' '}
                <strong style={{
                color: 'var(--ink)'
              }} data-id="element-563" data-mp="29kho97052td7">before it answers</strong>. What&rsquo;s binding goes first. A
                receipt proves what the model was told.
              </p>
              <p className="kicker" data-id="element-564" data-mp="1gxwujzw6y56h">Retrieval degrades gracefully. Obligations don&rsquo;t.</p>
              <div className="ctas" data-id="element-565" data-mp="1lv5cbzdfg777">
                <a className="btn g" href="#see-it" data-id="element-566" data-mp="1lyb4xol9lr7o">
                  See it in action &darr;
                </a>
                <Link className="btn o" to="/contact" data-id="element-567" data-mp="2xbdlijnd6gru">
                  Bring your highest standards &rarr;
                </Link>
              </div>
            </div>
          </div>
          <div className="col-r" data-id="element-568" data-mp="31f1sb04698c1">
            <PipelineDiagram data-id="element-569" data-mp="127paks3y2rvr" />
          </div>
        </div>
      </header>

      <div className="quoteband rt" data-id="element-570" data-mp="12a1rr31voy7r">
        <p data-id="element-571" data-mp="x9x7d1xunjc9">
          Your policies, your transcripts, your people&rsquo;s corrections &mdash; turned into a new kind of data:{' '}
          <span className="q" data-id="element-572" data-mp="1b83ylz8aml2y">instruction data</span> that
          <br data-id="element-573" data-mp="169agtulz47wz" />
          any model must follow.
        </p>
      </div>

      <div className="split" data-id="element-574" data-mp="ik7sy50qxiu1">
        <div className="sp-l" data-id="element-575" data-mp="ijg9fskfbbk4">
          <span className="clabel" data-id="element-576" data-mp="ikr8jf2xbv4w">Who it's for</span>
          <h2 style={{
          maxWidth: 'none',
          fontSize: 'clamp(23px,2.75vw,34px)'
        }} data-id="element-577" data-mp="ej62ackwaf3o">
            When AI speaks for
            <br data-id="element-578" data-mp="saasko2dhv1c" />
            your business, the answer
            <br data-id="element-579" data-mp="sbvr0ort5y4h" />
            becomes the record.
          </h2>
          <p className="lede" data-id="element-580" data-mp="nij54meik5ff">
            Ask it &ldquo;what&rsquo;s the capital of France?&rdquo; and there&rsquo;s nothing to record. Find
            &ldquo;Paris.&rdquo; Display &ldquo;Paris.&rdquo; But the moment your AI drafts the denial letter, answers
            the regulator, or approves the claim, the output stops describing your business and starts{' '}
            <strong data-id="element-581" data-mp="2b98oj7k80qqo">committing</strong> it.
          </p>
          <p className="lede" style={{
          marginTop: 14
        }} data-id="element-582" data-mp="2batnrahhcxuv">
            And the costly moments are the unscripted ones&mdash;the one-off email no template covers, the reply to an
            auditor nobody drafted in advance. You can&rsquo;t prewrite every consequential moment.
          </p>
          <p className="kicker" data-id="element-583" data-mp="2q6rbq5h92vw0">
            Synthia gives AI the instructions
            <br data-id="element-584" data-mp="2u69vuz18z2xs" />
            that moment requires.
          </p>
        </div>
        <div className="sp-r" data-id="element-585" data-mp="2g8lcjvmtw3uu">
          <Triage data-id="element-586" data-mp="2g7k1vs9q5jdn" />
        </div>
      </div>

      <div className="statband" data-id="element-587" data-mp="2l6mwsjvzq97w">
        <div data-id="element-588" data-mp="2l5lkkc38ngol">
          <div className="bignum" data-id="element-589" data-mp="2l5bt0k2jp1gs">68%</div>
          <div className="bignum-lab" data-id="element-590" data-mp="14swpz5dhl6uk">Adherence at high density</div>
        </div>
        <div data-id="element-591" data-mp="14uzoyewmaabf">
          <h2 data-id="element-592" data-mp="19rgdvbbn4spk">
            68% adherence isn&rsquo;t a benchmark. <span data-id="element-593" data-mp="19tazkruqkoup">It&rsquo;s a liability.</span>
          </h2>
          <p className="lede" data-id="element-594" data-mp="1p1wha04ji2u8">
            At high instruction density, even the best AI model tested missed nearly one in three instructions.
            <span style={{
            color: '#C2543C',
            fontWeight: 700,
            fontSize: '1.4em',
            lineHeight: 0,
            verticalAlign: '-0.14em'
          }} data-id="element-595" data-mp="1k9d95iomfzwt">
              *
            </span>{' '}
            In business, the missing obligation could be a style preference &mdash; or the disclosure that keeps you
            compliant.
          </p>
          <p className="fnote" data-id="element-596" data-mp="1yzaqpfs1prd1">
            <span style={{
            color: '#C2543C'
          }} data-id="element-597" data-mp="1yyhn2nodvhz4">*</span>{' '}
            <a href="https://arxiv.org/abs/2507.11538" target="_blank" rel="noopener noreferrer" data-id="element-598" data-mp="1u0pzu6yook19">
              IFScale, &ldquo;How Many Instructions Can LLMs Follow at Once?&rdquo;
            </a>{' '}
            At high density, the best-performing frontier model achieved 68% accuracy.
          </p>
        </div>
      </div>

      <div className="split split-seeit" id="see-it" data-id="element-599" data-mp="8i5izng78eiw">
        <div className="sp-l" data-id="element-600" data-mp="8fjanllhhuzm">
          <span className="clabel" data-id="element-601" data-mp="dfxgcwzm4suh">See it</span>
          <h2 data-id="element-602" data-mp="dgqh9hbw4o4p">
            Eleven words.
            <br data-id="element-603" data-mp="if0dlv9cpurw" />
            <span className="g" data-id="element-604" data-mp="ifa7vv1fio3e">Years of judgment.</span>
          </h2>
          <p className="lede" style={{
          maxWidth: '50ch'
        }} data-id="element-605" data-mp="n60a4zek6atv">
            A simple request carries more than it says. Hover over the underlined words to discover the expertise and
            obligations behind the answer &mdash; Synthia seats them along with the prompt{' '}
            <strong data-id="element-606" data-mp="w91f2wrotvvy">before the model&nbsp;answers</strong>.
          </p>
        </div>
        <div className="sp-r" data-id="element-607" data-mp="116t5tngljbyk">
          <SeeIt data-id="element-608" data-mp="1654ehuv5ngf7" />
        </div>
      </div>

      <div className="split" data-id="element-609" data-mp="163tdu3x0aosb">
        <div className="sp-l" data-id="element-610" data-mp="1631rzkt7o5f8">
          <span className="clabel" data-id="element-611" data-mp="32xo5wrhu5xb3">The rework tax</span>
          <h2 style={{
          maxWidth: '26ch'
        }} data-id="element-612" data-mp="32z90gh45hg8y">
            The most expensive token
            <br data-id="element-613" data-mp="37xaj50xnzdjw" />
            <span className="g" data-id="element-614" data-mp="37wrakatwm1ij">is the correction.</span>
          </h2>
          <p className="lede" data-id="element-615" data-mp="2zwuq4ia4myva">
            A missed fact costs a follow-up question. A missed obligation costs a rework loop, a compliance review, a
            customer apology &mdash; every downstream token spent undoing the first pass.
          </p>
          <p className="lede" style={{
          marginTop: 14
        }} data-id="element-616" data-mp="34uw9z5fdn27t">
            A missing disclosure doesn&rsquo;t <strong data-id="element-617" data-mp="34x8zc3ngseuw">partially comply</strong> &mdash; it&rsquo;s absent, and the
            absence is the incident.
          </p>
          <p className="kicker" data-id="element-618" data-mp="3dw489nhw831w">
            The loop buys fidelity by the token.
            <br data-id="element-619" data-mp="3sk7emxzulgr8" />
            The seat buys it once.
          </p>
        </div>
        <div className="sp-r" data-id="element-620" data-mp="3smbg79a9y3oc">
          <ReworkChart data-id="element-621" data-mp="3nkuhnkf9itax" />
        </div>
      </div>

      <div className="stoprow" data-id="element-622" data-mp="3nm5usaulldep">
        <div data-id="element-623" data-mp="5fralu5qk77v">
          <span className="clabel" data-id="element-624" data-mp="5f9gb32mw32l">The payoff</span>
          <h2 style={{
          marginTop: 18
        }} data-id="element-625" data-mp="5g0ync7804ax">What changes.</h2>
        </div>
      </div>

      <div className="grid4" data-id="element-626" data-mp="1fqum52znnyp">
        {PAYOFF.map(p => <div className="cell" key={p.n} data-id="element-627" data-mp="k1yduzdbs66c">
            <span className="gnum" aria-hidden="true" data-id="element-628" data-mp="k2zrnblq76rr">
              {p.n}
            </span>
            <div className="lab" data-id="element-629" data-mp="p117zorrorzj">
              <span data-id="element-630" data-mp="b1s2pk53niac">{p.lab}</span>
            </div>
            <h3 data-id="element-631" data-mp="b10563rxzahf">{p.title}</h3>
            <p data-id="element-632" data-mp="b3w5fyr9ib91">{p.body}</p>
          </div>)}
      </div>

      <div className="quoteband" data-id="element-633" data-mp="fzthvtzemxgj">
        <p data-id="element-634" data-mp="g2z9bfviabff">
          Models will misbehave in ways nobody has named yet.
          <br data-id="element-635" data-mp="1afagrfe2q3s" />
          When one does, the first question is always the same:
          <br data-id="element-636" data-mp="63qk10bl5kze" />
          <span className="q" data-id="element-637" data-mp="63gpr0jicrnw">what was it told?</span>
        </p>
      </div>

      <section className="keep" data-id="element-638" data-mp="3ohhe98q5haut">
        <div className="keep-grid" data-id="element-639" data-mp="3oiizu74slfqs">
          <div className="keep-copy" data-id="element-640" data-mp="3si9oo5ardlso">
            <span className="clabel" data-id="element-641" data-mp="3sjb6qtq6z8jw">What you keep</span>
            <h2 data-id="element-642" data-mp="3eiib25o5m7f7">
              The only part of your AI stack that appreciates.
            </h2>
            <p className="lede" data-id="element-643" data-mp="3jhlhnujs8lpa">
              It&rsquo;s the judgment your company has built through years of doing the work. Knowing what matters.
              Recognizing the exception. Understanding what a policy means when a customer is waiting for an answer.
            </p>
            <p className="lede" data-id="element-644" data-mp="3tyfe97t78m62">
              Synthia turns that expertise into <strong data-id="element-645" data-mp="3pxlla00wgh6b">a library of instruction data</strong> you own and can keep
              improving.
            </p>
            <p className="kicker" data-id="element-646" data-mp="3kzk1fcvngdts">
              Change the model.
              <br data-id="element-647" data-mp="3g1sb2nankzrp" />
              Keep the judgment.
            </p>
            <p style={{
            marginTop: 22
          }} data-id="element-648" data-mp="3baabo3oa378u">
              <Link className="il" to="/how" data-id="element-649" data-mp="3b8h4mn9r6l0b">
                See how it works →
              </Link>
            </p>
          </div>
          <div className="keep-art" data-id="element-650" data-mp="368kxwg9o8fh2">
            <div data-id="element-651" data-mp="32a551vqwscvq">
              <LibraryChart data-id="element-652" data-mp="32an8pdfwhtdo" />
            </div>
          </div>
        </div>
      </section>

      <div className="stoprow" data-id="element-653" data-mp="2x97p7ptdfuxe">
        <h2 style={{
        maxWidth: 'none'
      }} data-id="element-654" data-mp="2x9hj3ohjem8d">FAQs</h2>
      </div>

      <Faq data-id="element-655" data-mp="2sc7gt891ug34" />

      <CtaBand data-id="element-656" data-mp="2sch7yz5tytae" />
      <Ledger data-id="element-657" data-mp="2sby0kcdt3nam" />
    </>;
}